import { Manager, Pinch, Pan } from "hammerjs";

import ImageGallerySlideMobile from "./imageGallerySlideMobile";
import ImageGallery from "./../../../../common/components/imageGallery";

import {
  SWIPED_BACKWARD_GALLERY,
  SWIPED_FORWARD_GALLERY,
  VIEW_IMAGE_GALLERY,
} from "./../../../../common/analytics/analyticsevents";

export default class ImageGalleryMobile extends ImageGallery {
  resizedEnd = () => {
    const height = this.DOMContainer.querySelector(
      ".swiper-wrapper-imageviewer"
    ).getBoundingClientRect().height;
    //call update before and after, otherwise siwper is shifted when first zooming in 2the image and then rotating
    this.swiper.update(true);
    this.imageSlides.forEach((slide) => {
      slide.resize(height, this.options.imageviewerKeepScale);
    });
    this.swiper.update(true);
  };

  createImageViewerSlide(image) {
    const slide = new ImageGallerySlideMobile(
      this.appState,
      image,
      this.options.imageviewerslide
    );
    slide.on("imageViewerSlide:detachSwiperEvents", () => {
      this.detachSwiperEvents();
    });
    slide.on("imageViewerSlide:attachSwiperEvents", () => {
      this.attachSwiperEvents();
    });
    return slide;
  }

  attachSwiperEvents() {
    if (this.swiper) {
      this.swiper.attachEvents();
    }
  }

  detachSwiperEvents() {
    if (this.swiper) {
      this.swiper.detachEvents();
    }
  }

  createSwiper() {
    const selector = "#imageviewer .swiper-container-imageviewer";
    const a = document.querySelector(selector);
    if (a) {
      this.swiper = new Swiper($(a), {
        initialSlide: this.slideNumber,
        centeredSlides: true,
        pagination: $(a).find(" .swiper-pagination-imageviewer"),
        onInit: () => {
          this.appState.triggerEvent(VIEW_IMAGE_GALLERY);
        },
        onTransitionEnd: ({ activeIndex }) => {
          // if active index is not 0, it is called in the beginning
          this.imageSlides[activeIndex].renderHd();
          if (this.imageSlides[activeIndex].isZoomed()) {
            this.zoomed();
          } else {
            this.notZoomed();
          }
          if (
            this.lastIndex !== null &&
            this.swiper.activeIndex !== this.lastIndex
          ) {
            if (this.lastIndex < activeIndex) {
              this.appState.triggerEvent(SWIPED_FORWARD_GALLERY);
              this.appState.triggerEvent(VIEW_IMAGE_GALLERY);
            } else {
              this.appState.triggerEvent(SWIPED_BACKWARD_GALLERY);
              this.appState.triggerEvent(VIEW_IMAGE_GALLERY);
            }
          }
          this.lastIndex = activeIndex;
        },
        onTouchEnd: (swiper) => {
          swiper.unlockSwipeToPrev();
          swiper.unlockSwipeToNext();
        },
        onTouchStart: () => {
          this.checkSwiping();
        },
      });
    }
    this.appState.on("appState:heightChanged", this.resizedEnd);
  }

  initHammerSlide() {
    this.imageSlides.forEach((slide) => {
      slide.on("imageViewerSlide:notZoomed", () => {
        this.notZoomed();
      });
      slide.on("imageViewerSlide:zoomed", () => {
        this.zoomed();
      });
    });
    this.attachHammer();
  }

  removeListeners() {
    this.appState.off("appState:heightChanged", this.resizedEnd);
  }

  zoomed() {
    hidePagination();
  }

  notZoomed() {
    showPagination();
  }

  checkSwiping(e) {
    if (!this.swiper) {
      return;
    }
    const slide = this.imageSlides[this.swiper.activeIndex];
    const number = slide.allowSwiping(e);
    switch (number) {
      case 1:
        this.swiper.unlockSwipeToPrev();
        this.swiper.unlockSwipeToNext();
        break;
      case 2:
        this.swiper.lockSwipeToPrev();
        this.swiper.unlockSwipeToNext();
        break;
      case 3:
        this.swiper.unlockSwipeToPrev();
        this.swiper.lockSwipeToNext();
        break;
      default:
        this.swiper.lockSwipeToPrev();
        this.swiper.lockSwipeToNext();
    }
  }

  preventDefault = (e) => {
    e.preventDefault();
  };

  panning = (e) => {
    const slide = this.imageSlides[this.swiper.activeIndex];
    slide.panning(e);
  };

  panningEnd = (e) => {
    this.imageSlides[this.swiper.activeIndex].panningEnd(e);
    this.checkSwiping();
  };

  onPinch = (e) => {
    this.imageSlides[this.swiper.activeIndex].onPinch(e);
  };

  onPinchEnd = (e) => {
    const slide = this.imageSlides[this.swiper.activeIndex];
    slide.onPinchEnd(e);
    this.checkSwiping();
  };

  onPinchStart = (e) => {
    this.swiper.lockSwipeToPrev();
    this.swiper.lockSwipeToNext();
    this.imageSlides[this.swiper.activeIndex].onPinchStart(e);
  };

  attachHammer() {
    $(this.DOMContainer.querySelector(".swiper-wrapper-imageviewer")).on(
      "touchmove",
      this.preventDefault
    );
    this.mc = new Manager(
      this.DOMContainer.querySelector(".swiper-wrapper-imageviewer")
    );
    const pinch = new Pinch({
      threshold: 0.1,
    });
    const pan = new Pan();
    this.mc.add(pan);
    this.mc.add(pinch);
    this.mc.on("pan", this.panning);
    this.mc.on("panend", this.panningEnd);
    this.mc.on("pinch", this.onPinch);
    this.mc.on("pinchend", this.onPinchEnd);
    this.mc.on("pinchcancel", this.onPinchEnd);
    this.mc.on("pinchstart", this.onPinchStart);
  }
}

export function showPagination() {
  const selector =
    "#imageviewer .swiper-container-imageviewer .swiper-pagination-imageviewer";
  const a = document.querySelector(selector);
  if (a) {
    a.classList.remove("hidden");
  }
}

export function hidePagination() {
  const selector =
    "#imageviewer .swiper-container-imageviewer .swiper-pagination-imageviewer";
  const a = document.querySelector(selector);
  if (a) {
    a.classList.add("hidden");
  }
}



// WEBPACK FOOTER //
// ./src/touch/reader/components/imageGallery/imageGalleryMobile.js